<template>
  <section v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
    :element-loading-text="loadingText" fullsreen.lock="true" id="results-file-upload" class="results-upload-files">
    <div class="container-small-table">
      <div class="qc-upload-block">
        <div class="qc-upload-files-inputs">
          <el-form>
            <div class="case-type-input">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Case Type </label>

                      <el-select v-model="selectedCaseType" placeholder="Select Case Type" :filterable="true"
                        :clearable="true" default-first-option :loading="loadingData" @change="changeSelectedData">
                        <el-option v-for="(caseType, index) of getReportingPanels" :key="index" :value="caseType.value"
                          :label="caseType.case_name" :disabled="!caseType.reporting"></el-option>
                      </el-select>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.case_type
                      ">
                        {{ getSingleFileUploadErrors.case_type }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="case-creation__input" v-if="getAllUsers && getAllUsers.data">
                    <el-form-item>
                      <label for="text">
                        Test Performed by User
                        <span class="star">*</span>
                      </label>
                      <el-select v-model="selectedUser" filterable placeholder="Select User">
                        <el-option v-for="(user, index) in usersList" :key="index"
                          :label="user.first_name + user.last_name" :value="user._id"
                          :disabled="isInactiveStatus(user)">
                          <span style="float: left">{{
                            user.first_name + user.last_name
                          }}</span>
                          <span v-if="isInactiveStatus(user)" style="
                              float: right;
                              color: #eb5757;
                              font-size: 13px;
                              padding-left: 10px;
                            ">
                            Inactive
                          </span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div v-else class="case-creation__input">
                    <el-form-item>
                      <label for="text">
                        Test Performed by User
                        <span class="star">*</span>
                      </label>
                      <el-select v-model="selectedUser" filterable placeholder="Select User" disabled>
                        <el-option v-for="(user, index) in currentUserData" :key="index"
                          :label="user.first_name + user.last_name" :value="user._id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="toxicology-inputs" v-if="selectedCaseType == 'TOXICOLOGY'">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Result Type </label>

                      <el-select v-model="selectedResultType" placeholder="Select Result Type" :filterable="true"
                        :clearable="true" default-first-option>
                        <el-option v-for="(type, index) of resultTypes" :key="index" :value="type"
                          :label="type"></el-option>
                      </el-select>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.result_type
                      ">
                        {{ getSingleFileUploadErrors.result_type }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Result Date </label>

                      <el-date-picker v-model="selectedResultDate" type="date" placeholder="Select Result Date"
                        format="MM-DD-YYYY" value-format="YYYY-MM-DD" :disabled-date="disabledDate">
                      </el-date-picker>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.result_date
                      ">
                        {{ getSingleFileUploadErrors.result_date }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="toxicology-inputs" v-if="selectedCaseType == 'UTI'">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-0">
                      <label for="text"> Result Type </label>

                      <el-select v-model="selectedResultType" placeholder="Select Result Type" :filterable="true"
                        default-first-option>
                        <el-option v-for="(type, index) of resultTypesUTI" :key="index" :value="type"
                          :label="type"></el-option>
                      </el-select>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.result_type
                      ">
                        {{ getSingleFileUploadErrors.result_type }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="pgx-cnv-file-upload" :class="{ 'pgx-cnv-file-selected': IfCaseTypePGX }">
              <el-row :gutter="40">
                <el-col :span="24">
                  <ul>
                    <li>
                      <h3 class="upload-file-header">Result File</h3>
                      <ResultFileUpload @onUpdatedFile="selectedFile = $event"></ResultFileUpload>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.file
                      ">
                        {{ getSingleFileUploadErrors.file }}
                      </p>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.result_file
                      ">
                        {{ getSingleFileUploadErrors.result_file }}
                      </p>
                      <p class="err" v-else-if="
                        getFileUploadFormatErrors &&
                        getFileUploadFormatErrors.data
                      ">
                        {{ getFileUploadFormatErrors.data.message }}
                      </p>
                    </li>
                    <li v-if="selectedCaseType == 'PGX_TEST'">
                      <h3 class="upload-file-header">CNV File</h3>
                      <ResultFileUpload @onUpdatedFile="cnvFile = $event"></ResultFileUpload>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.cnf_file
                      ">
                        {{ getSingleFileUploadErrors.cnf_file }}
                      </p>
                      <p class="err" v-if="
                        getSingleFileUploadErrors &&
                        getSingleFileUploadErrors.error
                      ">
                        {{ getSingleFileUploadErrors.error }}
                      </p>
                    </li>
                  </ul>
                </el-col>

                <el-col :span="24">
                  <div class="upload-btn-group">
                    <el-button class="result-upload-btn" @click="submitFileUploadDetails"
                      :disabled="disableSubmitButton">
                      UPLOAD
                      <span class="el-icon-upload2 submit-btn-arrow"></span>
                    </el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
const ResultFileUpload = defineAsyncComponent(() =>
  import("@/components/fileUpload/ResultFileUpload")
);
export default {
  computed: {
    ...mapGetters("respiratoryFileUpload", [
      "getSingleFileUploadStatus",
      "getSingleFileUploadErrors",
      "getFileUploadFormatErrors",
    ]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    getReportingPanels() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        return this.getUserBasedCaseTypes(
          this.search_case_types.filter((e) => e.reporting)
        );
      } else {
        return this.search_case_types.filter((e) => e.reporting);
      }
    },
    disableSubmitButton() {
      if (
        this.selectedCaseType == "PGX_TEST" &&
        this.selectedFile &&
        this.cnvFile
      )
        return false;
      if (
        this.selectedCaseType == "TOXICOLOGY" &&
        this.selectedFile &&
        this.selectedResultType &&
        this.selectedResultDate
      )
        return false;
      if (
        this.selectedCaseType &&
        this.selectedFile &&
        ["PGX_TEST", "TOXICOLOGY"].indexOf(this.selectedCaseType) == "-1"
      )
        return false;
      return true;
    },
    IfCaseTypePGX() {
      if (this.selectedCaseType == "PGX_TEST") {
        return true;
      }
      return false;
    },
  },
  mixins: [caseDataHelper],
  components: { ResultFileUpload },
  async mounted() {
    this.loading = true;
    this.loadingText = "Loading...";
    await this.$store.commit(
      "respiratoryFileUpload/setSingleFileUploadErrors",
      null,
      { root: true }
    );
    await this.$store.commit("respiratoryFileUpload/setFileUploadError", null, {
      root: true,
    });
    await this.$store.commit("errors/clear", null, { root: true });

    await this.$store.dispatch("profile/fetchMyTestPanels", {
      include_test_details: true,
      get_all: true,
    });
    this.$store.dispatch("respiratoryFileUpload/resetErrors");
    await this.getLabCaseTypes();
    await this.setUserData();

    await this.fetchAllUserAccounts();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      search_case_types: [],
      formData: {},
      selectedFile: null,
      cnvFile: null,
      selectedCaseType: "",
      selectedUser: "",
      selectedResultType: "",
      selectedResultDate: "",
      resultTypes: ["SCREENING", "CONFIRMATION", "ETG/ETS"],
      resultTypesUTI: ["UTI"],
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },

      loadingData: false,
      usersList: [],
      currentUserData: [],
      loadingText: "",
    };
  },
  methods: {
    setUserData() {
      this.loading = true;
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.currentUserData.push(this.getAuthenticatedUser);
        this.selectedUser = this.getAuthenticatedUser._id;
      }
      this.loading = false;
    },
    async fetchAllUserAccounts() {
      try {
        this.loading = true;
        let params = {
          get_all: true,
          order_by: "first_name",
          order_type: "asc",
          status: "ACTIVE"
        };
        await this.$store.dispatch("userAccounts/fetchAllUserAccounts", params);
        if (this.getAllUsers && this.getAllUsers.data) {
          let usersForTestPerofmed = ["LAB_TECHNOLOGIST"];
          this.usersList = this.getAllUsers.data.filter((item) =>
            usersForTestPerofmed.includes(item.user_type)
          );
          let matchedUser = this.getAllUsers.data.find(
            (e) => e._id === this.getAuthenticatedUser._id
          );
          let users = ["LAB_ADMIN", "LAB_MANAGER"];
          if (users.includes(matchedUser.user_type)) {
            this.usersList.push(matchedUser);
            this.selectedUser = matchedUser._id;
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    changeSelectedData() {
      this.formData = {};
    },
    getLabCaseTypes() {
      this.search_case_types = this.getLabBasedCaseTypes(
        caseConstants.CASE_TYPES_DATA
      );
    },
    prepareFormData() {
      this.formData = new FormData();
      this.formData.append("result_file", this.selectedFile.raw);
      this.formData.append("case_type", this.selectedCaseType);
      this.formData.append("test_performed_by", this.selectedUser);

      if (this.selectedCaseType == "PGX_TEST") {
        this.formData.append("cnf_file", this.cnvFile.raw);
      }

      if (this.selectedCaseType == "TOXICOLOGY" && this.selectedResultType) {
        this.formData.append("result_type", this.selectedResultType);
      }

      if (this.selectedCaseType == "TOXICOLOGY" && this.selectedResultDate) {
        this.formData.append("result_date", this.selectedResultDate);
      }

      if (this.selectedCaseType === "UTI" && this.selectedResultType) {
        let resultType = this.selectedResultType;
        if (resultType === "UTI") {
          resultType = "ATILA_UTI";
        }
        this.formData.append("result_type", resultType);
      }
    },
    async submitFileUploadDetails() {
      try {
        await this.prepareFormData();
        this.loading = true;
        this.loadingText = "Uploading file...";
        await this.$store.dispatch(
          "respiratoryFileUpload/uploadSingleFile",
          this.formData
        );
        if (
          this.getSingleFileUploadStatus &&
          this.getSingleFileUploadStatus.success
        ) {
          this.$notify({
            title: "Success",
            message: this.getSingleFileUploadStatus.message,
            type: "success",
          });
          this.$router.push({
            name: "allResults",
            path: "/result-files",
          });
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
#results-file-upload {
  .qc-upload-block {
    border: 1.2px solid #e7e7f7;
    border-radius: 5px;
    margin: auto;
    width: 80%;

    .qc-upload-files-inputs {
      padding: 1rem 2rem;

      .el-input__inner {
        background: #ffffff;
        border: 0.639774px solid rgba(156, 156, 156, 0.5);
        border-radius: 3.83865px;
      }
    }

    .upload-files {
      margin-bottom: 0 !important;
    }
  }

  .pgx-cnv-file-upload {
    ul {
      li {
        .upload-file-header {
          font-size: 16px;
          padding: 7px 0;
          color: #2a2b2c;
        }

        .qc-upload-files {
          .qc-upload-button {
            .el-upload {
              display: block;

              .el-upload-dragger {
                width: 100%;
                height: 100px;
                background: #ffffff;
                border: 1px dashed #bababc;
                border-radius: 5px;
              }
            }

            .el-upload-text-align {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;

              .el-upload__text-img {
                display: flex;
                align-items: center;

                img {
                  width: 40px;
                  height: 40px;
                  padding: 0 10px;
                }
              }

              .el-upload-text {
                line-height: 14px;

                h3 {
                  color: #333333;
                  font-size: 18px;
                }

                p {
                  color: #828282;
                  font-size: 18px;
                }
              }
            }

            .el-upload-notes {
              color: #828282;
              font-size: 14px;
              font-weight: 500;
              padding: 10px 5px;
            }
          }

          .sample-attachment-file-block {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .sample-attachment-file {
              display: flex;
              align-items: center;
              border: 0.5px solid #e0e0e0;
              border-radius: 5px;
              margin: 1rem 0;

              img {
                padding: 0 10px;
              }
            }
          }
        }
      }
    }

    .upload-btn-group {
      text-align: end;
      margin-top: 15px;

      .el-button {
        background: #4bb543;
        border-radius: 3.40909px;
        width: 120px;
        min-height: 30px;
        height: 36px;
        border: none;
        color: white;

        &.result-upload-btn {
          background: #4bb543;
        }

        &.is-disabled {
          opacity: 0.5;
        }
      }
    }
  }

  .pgx-cnv-file-selected {
    ul {
      display: flex;

      li {
        width: 50%;
        margin-right: 20px;
      }
    }
  }
}
</style>
